window.Drupal = { behaviors: {} };

(function($) {

	/**
	 * Test if Placeholder attribute is available.
	 */
	if (Modernizr.input.placeholder) {
		$('html').addClass('placeholder');
	}

})(jQuery);

// File: add-ons.js

(function($, Drupal) {

	function createFullView(opts) {
		var openArticle = null;
		var openArticleOffset = 0;
		var element = $(opts.selector);
		var url = opts.url || '';
		var displayId = opts.displayId || 'article';

		return {
			insert: function(i) {
				$('.open-article-space', element).remove();
				$('div.teaser', element).eq(i).after('<div class="open-article-space" />');
				this.align();
				return this;
			},

			findSlot: function() {
				var found = false;
				var i = (openArticle) ? openArticle.index() : null;
				if (i === null) return;
				$('.open-article-space', element).remove();
				openArticleOffset = openArticle.offset().top;

				while(found === false) {
					var nextItem = $('div.teaser', element).eq(i + 1),
						nextItemOffset = 0;

					if (nextItem.length > 0) {
						nextItemOffset = $('div.teaser', element).eq(i + 1).offset().top;
					}

					if (nextItemOffset !== openArticleOffset) {
						found = true;
						this.insert(i);
					}
					i++;
				}

				return this;
			},

			align: function() {
				var openArticleTopPosition = 0;
				var openArticleTopOffset = 0;
				var openArticleHeight = 500;

				openArticleTopPosition = $('.open-article-space', element).position().top;
				openArticleTopOffset = $('.open-article-space', element).offset().top;

				$('html,body').animate({
					scrollTop: openArticleTopOffset - 100
				}, 300);

				this.loadFullViewArticle(openArticle.attr('data-nid'));
				return this;
			},

			loadFullViewArticle: function(nid) {
				var template = HBT.article_full;

				$.ajax({
					url: url,
					data: {
						nid: nid,
						display_id: displayId,
					}
				}).done(function(data) {
					for (var i = 0; i < data.length; i++) {
						if (data[i].typ == 'package') {
							data[i].linktext = Drupal.t('Read more');
							//data[i].linkurl = '';
						}

						if (!data[i].typ) {
							data[i].typ = displayId + ' ';
							// typ and type are concatenated without space in the template
						}

						data[i].maptext = Drupal.t('Map');
						var html = template(data[i]);
						$('.open-article-space', element).html(html);
						openArticle.addClass('open');
					}
				});
				return this;
			},

			close: function() {
				$('.open-article-space', element).remove();
				$('div.teaser.open', element).removeClass('open');
				return this;
			},

			init: function() {
				var _this = this;

				element.on('click', 'a.wrapper', function(e) {
					openArticle = $(this).parent().parent();
					$('.open', element).removeClass('open');

					openArticleOffset = openArticle.offset().top;
					$('.open-article-space', element).remove();
					setTimeout(_this.findSlot(), 250);
					e.preventDefault();
				});

				element.on('click', '.open-article-space .close-btn', function(e) {
					_this.close();
					e.preventDefault();
				});

				$(window).on('resize', function() {
					$('.open-article-space', element).remove();
					$('.open', element).removeClass('open');
				});

				$(window).on('resize', $.debounce(250, function() {
					$('.open-article-space', element).remove();
					setTimeout(_this.findSlot(), 250);
				}));

				return this;
			}
		};
	}

	function createExpandableList(opts) {
		var element = $(opts.selector);
		var loadClassOn = $(opts.loadClassOn);
		var sortBar = $(opts.sortBar);
		var url = opts.url;
		var displayId = opts.displayId;
		var listDisplayId = opts.listDisplayId;

		var eventList = element.find('.event-list');
		var loadMore = element.find('.load-more');

		var fullView = createFullView({
			selector: eventList,
			url: url,
			displayId: displayId,
		}).init();

		var data = {
			limit: 12,
			offset: 0,
			type: 'All'
		};

		var currentCount = 0;

		function loadArticles(reset) {
			var template = HBT.article_teaser;

			if (reset === true) {
				eventList.html('');
				loadMore.removeClass('disabled');
				currentCount = 0;
			}

			data.display_id = listDisplayId;
			data.offset = currentCount;
			loadClassOn.addClass('loading');

			$.ajax({
				url: url,
				data: data
			}).done(function(data) {
				if (!data.length) {
					loadMore.addClass('disabled');
				}

				var html = '';

				for (var i = 0; i < data.length; i++) {
					currentCount++;

					if (data[i].daily === '0') {
						delete data[i].daily;
					}

					if (data[i].dagligen === '0') {
						delete data[i].dagligen;
					}

					if (!data[i].typ) {
						data[i].typ = displayId + ' ';
						// typ and type are concatenated without space in the template
					}

					html += template(data[i]);
				}

				eventList.append(html);

				// Lazy load newly added images.
				$('img.lazy', element).lazyload({
					effect: 'fadeIn',
					event: 'ladda'
				}).removeClass('lazy').trigger('ladda');

			}).always(function() {
				loadClassOn.removeClass('loading')
			});
		}

		loadArticles(true);

		$('a', sortBar).on('click', function(e) {
			var target = $(this).attr('data-target');
			var filter = $(this).attr('data-filter');

			if (target === 'type' && data.type !== filter) {
				data.type = filter;
				loadArticles(true);
			} else if (target === 'all' && filter === 'All') {
				data.type = 'All';
				loadArticles(true);
			}

			$('a.active', sortBar).removeClass('active');
			$(this).addClass('active');

			fullView.close();

			e.preventDefault();
		});

		element.on('click', '.load-more', function(e) {
			if (!$(this).hasClass('disabled')) {
				loadArticles();
			}
			e.preventDefault();
		});
	}

	Drupal.behaviors.addOns = {
		attach: function(c, settings) {
			if ($('#add-ons').length > 0) {
				var addOnsList = createExpandableList({
					selector: '#add-ons .events',
					sortBar: '#add-ons .sort-bar',
					loadClassOn: '#add-ons',
					url: settings.addonsApiUrl,
					displayId: 'article',
					listDisplayId: 'services_1'
				});
			}

			if ($('#offers').length > 0) {
				var offersList = createExpandableList({
					selector: '#offers .events',
					loadClassOn: '#offers',
					url: settings.offersApiUrl,
					displayId: 'offer',
					listDisplayId: 'offers'
				});
			}
		}
	}
})(jQuery, Drupal);

// social.js
(function($){
	Drupal.behaviors.social = {
		attach: function(c, settings) {

	url = settings.socialApiUrl;

	var data = {
		limit: 12,
		offset: 0
	};

	var context = $('#social .social');

	var currentCount = 0;

	function loadSocialItems() {
		var templates = {
			instagram: HBT.social_instagram,
			tweet: HBT.social_tweet
		}

		data.offset = currentCount;
		$('#social').addClass('loading');

		$.ajax({
			url: url,
			data: data
		}).done(function(data) {
			var html = '';

			for (var i = 0; i < data.length; i++) {
				var currentTemplate = templates[data[i].type];

				if (typeof currentTemplate === 'function') {
					currentCount++;
					html += currentTemplate(data[i]);
				}
			}

			$('.social-list', context).append(html);

			// Lazy load newly added images.
			$('img.lazy', context).lazyload({
				effect: 'fadeIn'
			}).removeClass('lazy');

		}).always(function() {
			$('#social').removeClass('loading')
		});
	}

	$(document).ready(function() {
		loadSocialItems();

		$(document).on('click', '#social .load-more', function(e) {
			loadSocialItems();
			e.preventDefault();
		});
	});
		}
	}

})(jQuery);
// File: rooms-details.js
(function($) {
	$('.details-toggle').on('click', function(e) {
		$(this).parent().toggleClass('open');
		const label = $(this).parent().hasClass('open') ? window.umeLocalize.hideFacts : window.umeLocalize.showFacts;
		$(this).text( label);
		e.preventDefault();
	});
})(jQuery);
// File: rooms-flexslider.js
(function($) {
	$(window).on('load', function() {
		var isFrontPage = !!$('body.front').length;
		var animationSpeed = 600;
		var slideshowSpeed = 7000;

		var checkVid = function() {
			var video = slider.find('.flex-active-slide video')[0];
			var rawSlider = slider.data('flexslider');
			if (video && !Modernizr.video) {
				rawSlider.removeSlide(rawSlider.currentSlide);
			} else if (video && Modernizr.video) {
				var duration = video.duration * 1000 - animationSpeed * 1.5  - slideshowSpeed;
				rawSlider.pause();
				setTimeout(function(){
					rawSlider.play();
					setTimeout(function() {
						video.pause();
						video.currentTime = 0;
					}, animationSpeed + slideshowSpeed)
				}, duration );

				if (!matchMedia('prefers-reduced-motion: reduce').matches) {
					video.play();
				}
			}
		};

		var slider = $('.flexslider').flexslider({
			controlNav: false,
			animation: "slide",
			slideshow: !isFrontPage,
			animationSpeed,
			slideshowSpeed,
			after: function() {
				checkVid();
			}
		});

		var videos = slider.find('.flex-active-slide video');
		videos.on('click', function() {
			var video = $(this)[0];
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
		});

		checkVid();
	});
})(jQuery);
// File: booking.js
(function($) {
	$('.toggle-extra-options').on('click', function(e) {
		$(this).parent().addClass('open');

		$(document).on('click.outside', function(e) {
			if (!$('.extra-options-wrapper').has(e.target).length) {
				$('.toggle-extra-options').parent().removeClass('open');
				$(document).off('click.outside');
			}
		});
		e.preventDefault();
	});

	$('.toggle-booking').on('click', function(e) {
		var form = $('#block-resmaster-bookingmask');
		form.toggleClass('open');

		$(this).attr('aria-expanded', form.hasClass('open') ? 'true' : 'false');

		e.preventDefault();
	});

	var editAdults = $('#edit-adults');
	var editChildren = $('#edit-children');

	function handlePeopleChange(ev) {
		var thisSelect = $(ev.target);
		var otherSelect = ev.target === editAdults[0] ? editChildren : editAdults;

		var thisSelectValue = parseInt(thisSelect.val(), 10);
		var otherSelectValue = parseInt(otherSelect.val(), 10);
		if (thisSelectValue + otherSelectValue > 4) {
			otherSelect.val(4 - thisSelectValue);
		}
	}

	editAdults.on('change', handlePeopleChange);
	editChildren.on('change', handlePeopleChange);
	
})(jQuery);
// file: matrix.js
(function($) {
	$('.matrix button[data-open]').on('click', function(e) {
		$('.matrix').toggleClass('open');

		if (!$('.matrix').hasClass('open')) {
			$('.matrix-content').off('click.outsidematrix');
		}

		$('.matrix-content').on('click.outsidematrix', function(e) {
			if (!$('.matrix-content > div').has(e.target).length) {
				$('.matrix').removeClass('open');
				$('.matrix-content').off('click.outsidematrix');
			}
		});
		e.preventDefault();
	});

	$('.matrix button[data-close]').on('click', function(e) {
		$('.matrix').removeClass('open');
		$('.matrix-content').off('click.outsidematrix');
		e.preventDefault();
	});
})(jQuery);

// File: nav-toggle.js
(function($) {
	$('.nav-toggle').on('click', function(e) {
		var parent = $(this).parent();
		parent.toggleClass('open');

		$(this).attr('aria-expanded', parent.hasClass('open') ? 'true' : 'false');
		e.preventDefault();
	});
})(jQuery);

// Close hamburger menu when clicking on a link in the menu
(function($) {
	$('.menu-item').on('click', function(e) {
		$(this).closest('#navigation-primary').removeClass('open');
	});
})(jQuery);
